import apiClient, { extractData } from "./client";

export async function getWorkflows() {
  const response = await apiClient.get("/workflows");
  return extractData(response);
}

export async function getWorkflowApproverRoles() {
  const response = await apiClient.get("/workflows/approver-roles");
  return extractData(response);
}

export async function createCustomWorkflow(data) {
  const response = await apiClient.post("/workflows/custom", data);
  return extractData(response);
}

export async function updateWorkflow(id, data) {
  const response = await apiClient.put(`/workflows/${id}`, data);
  return extractData(response);
}
